import React from "react";
import { BrowserRouter } from 'react-router-dom';
import RouteComponent from "../routes";
import './App.scss';

const App = () => {

    const [ isLoading, loadingDone ] = React.useState(true);

    React.useEffect(() => {

        const loader = document.getElementById('loader-container');
        loader.remove();
        loadingDone(false);
    }, []);

    console.log(isLoading);

    if (isLoading) {
        return null;
    }

    return (
        <BrowserRouter>
            <RouteComponent />
        </BrowserRouter>
    );
}

export default App;
